import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "date-time"
}
const _hoisted_4 = {
  key: 1,
  class: "date-time"
}
const _hoisted_5 = { class: "date-time" }
const _hoisted_6 = { class: "date-time" }
const _hoisted_7 = {
  key: 2,
  class: "dog"
}
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.eventDetail)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "scrim",
        id: "event-tooltip",
        onClick: _withModifiers($setup.closeDetail, ["self"])
      }, [
        _createElementVNode("div", {
          class: "card",
          style: _normalizeStyle({'--bkg-color': $setup.calColor})
        }, [
          _createElementVNode("div", { class: "header" }, [
            _createElementVNode("div", {
              class: "close",
              onClick: $setup.closeDetail
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M19 6.4L17.6 5L12 10.6L6.4 5L5 6.4L10.6 12L5 17.6L6.4 19L12 13.4L17.6 19L19 17.6L13.4 12L19 6.4Z",
                  fill: "#000013"
                })
              ], -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString($setup.props.eventDetail.event.title), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "underline" }, null, -1)),
            (!$setup.endTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.startDate) + " - " + _toDisplayString($setup.endDate), 1))
              : _createCommentVNode("", true),
            ($setup.endTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString($setup.startDate), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString($setup.startTime) + " - " + _toDisplayString($setup.endTime), 1)
                ]))
              : _createCommentVNode("", true),
            ($props.dogInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", null, "Dog's name: " + _toDisplayString($props.dogInfo.name), 1),
                  ($setup.ownerName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Owner's name: " + _toDisplayString($setup.ownerName), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, "Dog's size: " + _toDisplayString($props.dogInfo.size), 1),
                  _createElementVNode("p", null, "Dog's weight: " + _toDisplayString($props.dogInfo.weight), 1),
                  _createElementVNode("p", null, "Dog's breed: " + _toDisplayString($props.dogInfo.breed), 1),
                  _createElementVNode("p", null, "Dog's ID: " + _toDisplayString($props.dogInfo.$id), 1),
                  _createElementVNode("p", null, "Owner's ID: " + _toDisplayString($props.dogInfo.owner), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}